export function IconPhone() {
  return (
    <svg width="32" height="32" viewBox="0 0 40 40" fill="none">
      <rect width="40" height="40" rx="6" fill="#FDEBF6" />
      <g clipPath="url(#clip0_751_8959)">
        <path
          d="M23.5094 12.8809C24.4861 13.0714 25.3838 13.5491 26.0875 14.2528C26.7911 14.9565 27.2688 15.8541 27.4594 16.8309M23.5094 8.88086C25.5387 9.1063 27.431 10.015 28.8756 11.4579C30.3203 12.9007 31.2314 14.7919 31.4594 16.8209M30.4594 24.8009V27.8009C30.4605 28.0794 30.4035 28.355 30.2919 28.6102C30.1803 28.8654 30.0167 29.0944 29.8115 29.2827C29.6063 29.471 29.364 29.6143 29.1002 29.7036C28.8363 29.7928 28.5568 29.8259 28.2794 29.8009C25.2022 29.4665 22.2464 28.415 19.6494 26.7309C17.2332 25.1955 15.1847 23.147 13.6494 20.7309C11.9594 18.1221 10.9076 15.1519 10.5794 12.0609C10.5544 11.7843 10.5873 11.5056 10.6759 11.2425C10.7645 10.9793 10.907 10.7375 11.0942 10.5325C11.2814 10.3274 11.5092 10.1636 11.7632 10.0514C12.0172 9.93919 12.2917 9.88112 12.5694 9.88086H15.5694C16.0547 9.87608 16.5252 10.0479 16.8932 10.3644C17.2611 10.6808 17.5015 11.1203 17.5694 11.6009C17.696 12.5609 17.9309 13.5036 18.2694 14.4109C18.4039 14.7688 18.4331 15.1578 18.3533 15.5317C18.2736 15.9057 18.0883 16.249 17.8194 16.5209L16.5494 17.7909C17.973 20.2944 20.0459 22.3673 22.5494 23.7909L23.8194 22.5209C24.0913 22.252 24.4346 22.0667 24.8085 21.987C25.1825 21.9072 25.5715 21.9363 25.9294 22.0709C26.8367 22.4094 27.7793 22.6442 28.7394 22.7709C29.2252 22.8394 29.6688 23.0841 29.9859 23.4584C30.3031 23.8326 30.4716 24.3104 30.4594 24.8009Z"
          stroke="#FF94D5"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_751_8959">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(8.45898 7.88086)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
